<template>
    <v-dialog v-model="dialog" persistent max-width="400px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
          >Edit Client
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Edit Client</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
            >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="client.name"
                  label="Client Name"
                  type="text"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="client.email"
                  label="Client Email"
                  type="email"
                  :rules="[v => !!v || 'Item is required',v => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="client.mobile"
                  label="Mobile No"
                  type="number"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="client.gst"
                  label="Client Gst No"
                  type="text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="client.address"
                  label="Client Address"
                  :rules="[v => !!v || 'Item is required']"
                  type="text"
                  required
                ></v-text-field>
              </v-col>

              
            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="success darken-1" text @click="editclient1()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
  export default {
    props : {
        clientid : Number
    },
    data: function() {
      return {
        valid: true,
        dialog: false,
        client: ''
      }
    },
    computed: {
      ...mapGetters(["allclients"])
    },
    created () {
      let client1 = this.allclients.filter(product => product.id === this.clientid);
      this.client = client1[0];
    },
    methods:{
      ...mapActions(['editclient']),
      editclient1() {
        if(this.$refs.form.validate())
        {
          this.editclient(this.client);
          this.dialog = false;
        }
      }
    }
  }
</script>